import { getP2pOptionLogo } from '@/lib/p2p'
import type { P2PMarket, P2PMarketOption } from '@/types/p2p'

interface P2pOptionSectionHeaderProps {
	option: P2PMarketOption
	market: P2PMarket
}

export function P2pOptionSectionHeader({ option, market }: P2pOptionSectionHeaderProps) {
	return (
		<div className='flex items-center gap-2.5'>
			<img src={getP2pOptionLogo(option, market)} alt='' className='h-7 w-7 rounded-full object-cover' />
			<span className='text-base font-medium tracking-[-0.24px] text-foreground'>{option.name}</span>
		</div>
	)
}
